import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
const ListTop = styled.div`
  width: 100%;
  height: 52px;
  padding: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: #f7f8f9;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  font-size: 14px;
  font-weight: 700;
  line-height: 145%;
  color: #616161;
`;

const ListBox = styled.div`
  width: 100%;
  padding: 24px 16px 72px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #ffffff;
`;
const List = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
interface ListCardProps {
  isActive: boolean;
}

const ListCard = styled.div<ListCardProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(23, 30, 38, 0.1);
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
  cursor: pointer;
`;

const ItemInfoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 30, 38, 0.56);
`;
const ItemTypeChip = styled.span`
  width: 42px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 500;
`;

const ListCardContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: start;
  gap: 16px;
`;
const CardTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CardImgBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
`;

const Tag = styled.span`
  width: 42px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  background: #ffdbd6;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #d84836;
`;

const CardCategory = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 700;
  color: #008aff;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CardTitle = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #171e26;
  line-height: 150%;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const CardPrice = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  strong {
    font-weight: 700;
  }
`;

const Status = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  color: rgba(55, 56, 60, 0.61);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.28px;
  strong {
    color: #222;
  }
`;
const BidPrice = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #008aff;
  strong {
    font-weight: 700;
  }
`;

const CardDateBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const HashTagWrapper = styled.div`
  width: 220px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  flex-wrap: wrap;
`;
const TagText = styled.span`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(112, 115, 124, 0.08);
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BidTag = styled.span`
  font-size: 12px;
  font-weight: 500;
  color: #f45551;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #ffefef;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BidTag02 = styled.span`
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  background-color: rgba(112, 115, 124, 0.08);
  color: #222;
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const BidTag03 = styled.span`
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: rgba(112, 115, 124, 0.08);
  color: rgba(55, 56, 60, 0.61);
  display: flex;
  flex-direction: row;
  align-items: center;
`;
const ViewCount = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-size: 12px;
  font-weight: 400;
  color: rgba(55, 56, 60, 0.61);
`;
const Nodata = styled.div<{ $isCompact?: boolean }>`
  width: 100%;
  height: 240px;
  padding: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  color: #616161;

  ${({ $isCompact }) => $isCompact && 'height: auto;'}
`;
const InterestBox = styled.div`
  width: 100%;
  padding: 6px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid rgba(112, 115, 124, 0.16);
  background-color: #f7f8fc;
  font-family: Spoqa Han Sans Neo;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
  position: relative;
`;

const Rating = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const RatingText = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;
const MemoBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`;
const EditBox = styled.div`
  width: 180px;
  padding: 8px 0;
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 31px;
  right: 0;
  border-radius: 16px;
  background-color: #fff;
  box-shadow:
    0px 2px 8px 0px rgba(0, 0, 0, 0.12),
    0px 1px 4px 0px rgba(0, 0, 0, 0.08),
    0px 0px 1px 0px rgba(0, 0, 0, 0.08);
  z-index: 999;
`;
const EditBoxRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 20px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
const MoreText = styled.button`
  font-family: Spoqa Han Sans Neo;
  font-size: 12px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.28);
  background: none;
  border: none;
  cursor: pointer;
  border: none;
  background: none;
  white-space: nowrap;
  margin-left: 4px;
`;

export const s = {
  Container,
  ListTop,
  ListBox,
  List,
  ListCard,
  ListCardContentBox,
  CardTextBox,
  CardImgBox,
  Tag,
  CardCategory,
  CardTitle,
  CardPrice,
  Status,
  CardDateBox,
  HashTagWrapper,
  TagText,
  ItemInfoBox,
  ItemTypeChip,
  BidPrice,
  BidTag,
  BidTag02,
  BidTag03,
  ViewCount,
  Nodata,
  InterestBox,
  Rating,
  RatingText,
  MemoBox,
  EditBox,
  EditBoxRow,
  MoreText,
};
